import { createFileRoute } from '@tanstack/react-router';
import { ProviderCredentialsSettings } from '@/components/providers/provider-credentials-settings';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/enrichment/providers',
)({
  component: () => <ProviderCredentialsSettings header={false} />,
});
